module.exports = __webpack_public_path__ + "static/img/Tesi-Niu.4197857.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tesi-Niu.jpg
// module id = qCcu
// module chunks = 0